module.exports = __webpack_public_path__ + "static/media/hero_mobile.b06e1f2a.webp";